import React from 'react';
import MediaQuery from 'react-responsive';

import './Industry.css';
import IndustryImage from '../../images/home/home-industry-oculus.png';

function IndustrySection() {
  return (
    <div className="IndustrySection">
      <div className="title">
        <p>
          Desenvolvemos soluções inovadoras através
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            {' '}
          </MediaQuery>
          de aplicações multi-disciplinares visando
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            {' '}
          </MediaQuery>
          <span>gerar impacto no mercado com tecnologia de ponta.</span>
        </p>
      </div>
      <div className="industriesList">
        <ul>
          <li>AGRONEGÓCIO</li>
          <li>INDÚSTRIA 4.0</li>
          <li>VAREJO</li>
          <li>EDUCAÇÃO</li>
          <li>ENGENHARIA</li>
          <li>SAÚDE</li>
        </ul>
        <img src={IndustryImage} alt="man with HMD and bracelet controlling game on tv" />
      </div>
    </div>
  );
}

export default IndustrySection;
